// src/pages/income/service/IncomeServiceDraftList.jsx
// ✅ 용역사업 "수입목록" — _shared/IncomeDraftList.jsx(공통 컴포넌트)를 그대로
// 재사용한다. 이 페이지는 종류 선택 그리드가 없는 독립 작성 페이지(IncomeServiceDraftNew)
// 라 전용 config 팩토리(incomeDraftConfig.js)는 안 쓰지만, 목록은 다른 3개 사업과
// 동일한 표/필터/뱃지가 필요하므로 그 부분만 최소 config로 그대로 연결한다.
// 청구형(내부기안+공문)은 IncomeServiceIncome 2행으로 각각 별도 표시된다
// (draft_kind로 구분, 이 목록에서는 별도 표기 없이 각자의 기안상태를 보여줌).
import React from "react";
import IncomeDraftList from "../_shared/IncomeDraftList";

const config = {
  dataApiBase: "/income-service/",
  newRoutePath: "/income/service/draft/new",
  businessLabel: "용역사업",
  tabTitle: "용역",
  listRefreshChannelName: "income-service-draft-list-refresh",
};

export default function IncomeServiceDraftList() {
  return <IncomeDraftList config={config} />;
}
